<div id="pagination" class="pagination" fxLayout.lt-md="column">
  @if (pagination.totalRecords !== 0) {
    <div class="itemCount">
      <span class="dark-text">
        @if (pagination.from && pagination.to) {
          <span class="dark-text">
            {{ 'pagination.displaying' | translate }} <strong>{{ pagination.from }}</strong>
            {{ 'pagination.to' | translate }} <strong>{{ pagination.to }}</strong>
          </span>
        }
        @if (!pagination.from && !pagination.to) {
          <span class=""> 0 - 0 </span>
        }
        {{ 'pagination.from' | translate }}
        <span class="form-to-page">{{ pagination.totalRecords }}</span>
        {{ title ? title : ('pagination.' + service.cid | translate) }}
      </span>
    </div>
  }
  @if (pagination.totalRecords !== 0) {
    <div class="d-flex pages-container">
      <pagination-template
        #p="paginationApi"
        maxSize="5"
        (pageChange)="pageChanged($event)"
        class="d-flex pages-container"
      >
        <div class="pagination-previous" [class.disabled]="p.isFirstPage()">
          <a (click)="goToFirstPage()"> <mat-icon [svgIcon]="'two-prev-arrow'" [attr.size]="'16px'"></mat-icon> </a>
        </div>
        <div class="pagination-previous" [class.disabled]="p.isFirstPage()">
          <a (click)="p.previous()"> <mat-icon [svgIcon]="'prev-arrow'" [attr.size]="'16px'"></mat-icon> </a>
        </div>
        <div class="list-pages">
          @for (page of p.pages; track page) {
            <div>
              @if (p.getCurrent() !== page.value) {
                <a (click)="pageChanged(page.value)">
                  <span [class.current]="p.getCurrent() === page.value">{{ page.label }}</span>
                </a>
              }
              @if (p.getCurrent() === page.value) {
                <div>
                  <span [class.current]="p.getCurrent() === page.value">{{ page.label }}</span>
                </div>
              }
            </div>
          }
        </div>
        <div class="pagination-next" [class.disabled]="p.isLastPage()">
          <a (click)="goToNextPage(p.getCurrent() + 1)">
            <mat-icon [svgIcon]="'next-arrow'" [attr.size]="'16px'"></mat-icon>
          </a>
        </div>
        <div class="pagination-next" [class.disabled]="p.isLastPage()">
          <a (click)="goToLastPage()">
            <mat-icon [svgIcon]="'two-next-arrow'" [attr.size]="'16px'"></mat-icon>
          </a>
        </div>
      </pagination-template>
      <!-- <div class="currentPage dark-text" fxFlex fxLayout fxLayoutAlign="center center">
      <span>{{ 'pagination.page' | translate }}</span>
      <input
        type="number"
        class="current-page-input"
        [min]="1"
        [max]="pagination.lastPage"
        value="1"
        (change)="setPage($event?.target?.value)"
        matInput
        [attr.testId]="'page'"
        #currentPageInput
        />
        <span>{{ 'pagination.of' | translate }} {{ pagination.lastPage }}</span>
      </div>
      <button mat-icon-button class="paginator-btn" [disabled]="currentPage == 1" (click)="setPageNav('prev')">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button
        mat-icon-button
        class="paginator-btn"
        [disabled]="currentPage === pagination.lastPage"
        (click)="setPageNav('next')"
        >
        <mat-icon>chevron_right</mat-icon>
      </button> -->
    </div>
  }
</div>
